import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { slugifyHeading } from '@/utils/glossary-toc';

const extractText = (node) => {
  if (typeof node === 'string') return node;
  if (Array.isArray(node)) return node.map(extractText).join('');
  if (node && node.props && node.props.children) return extractText(node.props.children);
  return '';
};

const HeadingWithId = ({ tag: Tag, children }) => {
  const text = extractText(children);
  const id = slugifyHeading(text);
  return <Tag id={id}>{children}</Tag>;
};

const markdownComponents = {
  h2: ({ children }) => <HeadingWithId tag="h2">{children}</HeadingWithId>,
  h3: ({ children }) => <HeadingWithId tag="h3">{children}</HeadingWithId>
};

const GlossaryRichText = ({ richTextMarkdownContent: content }) => {
  if (!content) return null;

  return (
    <div className="glossary-prose max-w-none">
      <Markdown rehypePlugins={[rehypeRaw]} components={markdownComponents}>
        {content}
      </Markdown>
    </div>
  );
};

export default GlossaryRichText;
